export default __webpack_public_path__ + "static/media/benefits.1f6357d9.svg";